import { TabSelectorEntity } from './Mobile/TabSelector';

/*
 * Which tab the engineer should be standing on once the visible tab list changes (MMG-4405).
 *
 * Answering an In Use gate "Not in Use" drops that tab out of the bar while the engineer is looking
 * at it, so somebody has to move them. Lives here rather than in the component because it is a
 * user-visible three-branch rule and this repo has no React Testing Library.
 *
 * staticTabKeys are the tabs rendered outside the measurement tab list - Photos, Parts, and the
 * DamageCodes key - which stay valid no matter what the gate does. The caller supplies
 * them because which of them exist depends on job type and history mode.
 */
export const resolveNextActiveTab = (
    currentTabKey: string | number,
    visibleTabs: TabSelectorEntity[],
    staticTabKeys: Array<string | number>,
    fallbackTabKey: string | number
): string | number => {
    if (staticTabKeys.includes(currentTabKey)) {
        return currentTabKey;
    }

    if (visibleTabs.some((tab: TabSelectorEntity) => tab.id === currentTabKey)) {
        return currentTabKey;
    }

    // Hidden tab: prefer a sibling that is still in the bar, otherwise hand back the caller's
    // fallback (Photos/Parts) rather than stranding the engineer on a tab they cannot see.
    const firstVisibleTab = visibleTabs[0];
    return firstVisibleTab !== undefined ? firstVisibleTab.id : fallbackTabKey;
};
